import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import Breadcrumbs from 'react-router-dynamic-breadcrumbs';
import { Redirect } from 'react-router-dom';

import {
  APIHandler,
  BackButton,
  Collection,
  DataHandler,
  ImageCollection,
} from 'C4';
import { storageKeys } from 'settings';

export default class CollectionView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      collection: [],
      escaped: false,
    };

    this.onEsc = this.onEsc.bind(this);
  }

  componentWillMount() {
    const { url } = this.props.match;
    document.addEventListener('keydown', this.onEsc);
    DataHandler.matchAppId().then((id) => {
      const appId = id;

      if (url.split('/').slice(-1).pop() === 'images') {
        DataHandler.checkKey(storageKeys.images, APIHandler.getImages(appId))
          .then(res => this.setState({ collection: res.items }));
      }

      if (url.split('/').slice(-1).pop() === 'malibu-consumer-videos') {
        APIHandler.getCollection(968)
          .then(res => this.setState({ collection: res.items }));
      }
      if (url.split('/').slice(-1).pop() === 'malibu-consumer-files') {
        APIHandler.getCollection(1115)
          .then(res => this.setState({ collection: res.items }));
      }
      if (url.split('/').slice(-1).pop() === 'axis-consumer-videos') {
        APIHandler.getCollection(970)
          .then(res => this.setState({ collection: res.items }));
      }
      if (url.split('/').slice(-1).pop() === 'workbooks') {
        APIHandler.getCollection(878)
          .then(res => this.setState({ collection: res.items }));
      }
      if (url.split('/').slice(-1).pop() === 'malibu-competitive-comparisons') {
        APIHandler.getCollection(885)
          .then(res => this.setState({ collection: res.items }));
      }
      if (url.split('/').slice(-1).pop() === 'axis-competitive-comparison') {
        APIHandler.getCollection(962)
          .then(res => this.setState({ collection: res.items }));
      }
      if (url.split('/').slice(-1).pop() === 'malibu-competitive-analysis') {
        APIHandler.getCollection(875)
          .then(res => this.setState({ collection: res.items }));
      }
      if (url.split('/').slice(-1).pop() === 'axis-competitive-analysis') {
        APIHandler.getCollection(965)
          .then(res => this.setState({ collection: res.items }));
      }
      if (url.split('/').slice(-1).pop() === 'product-overview') {
        APIHandler.getCollection(876)
          .then(res => this.setState({ collection: res.items }));
      }
      if (url.split('/').slice(-1).pop() === 'sales-training-videos') {
        APIHandler.getCollection(873)
          .then(res => this.setState({ collection: res.items }));
      }
      if (url.split('/').slice(-1).pop() === 'dealer-programs') {
        APIHandler.getCollection(969)
          .then(res => this.setState({ collection: res.items }));
      }
    });
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onEsc);
  }

  onEsc(e) {
    if (e.key === 'Escape') {
      this.setState({ escaped: true });
    }
  }

  render() {
    const { escaped, collection } = this.state;

    const { url, params } = this.props.match;
    const { videoId } = params;

    const redirPath = (
      videoId !== undefined
        ? url.substring(0, url.lastIndexOf('/')).lastIndexOf('/')
        : url.lastIndexOf('/')
    );

    return (
      <div className="collection__Container">
        <div className="collection__Background--overlay" />
        {url.split('/')[2] === 'sell' &&
          <BackButton to="/main/sell" />
        }
        {url.split('/')[2] === 'promote' &&
          <BackButton to="/main/promote" />
        }

        {url.split('/').slice(-1).pop() === 'malibu-consumer-videos' &&
          Object.keys(collection).map(key => (
            <div className="videos">
              <Collection
                key={collection[key][0].pageID}
                content={collection[key]}
                header={key}
              />
            </div>
          ))}
        {url.split('/').slice(-1).pop() === 'axis-consumer-videos' &&
          Object.values(collection).map(col => (
            <div className="videos">
              <Collection
                key={col[0].pageID}
                content={col}
                header="axis consumer videos"
              />
            </div>
          ))}
        {url.split('/').slice(-1).pop() === 'images' &&
          Object.values(collection).map(chapter => (
            <ImageCollection
              key={chapter[0].chapter.chapterNumber}
              chapterCollection={chapter}
            />
          ))}
        {url.split('/').slice(-1).pop() === 'brochures' &&
          Object.values(collection).map(col => (
            <div className="brochures">
              <Collection
                key={col[0].chapter.chapterNumber}
                content={col}
              />
            </div>
          ))}
        {url.split('/').slice(-1).pop() === 'malibu-consumer-files' &&
            Object.values(collection).map(col => (
              <div className="brochures">
                <Collection
                  key={col[0].pageID}
                  content={col}
                />
              </div>
          ))}
        {url.split('/').slice(-1).pop() === 'workbooks' &&
            Object.values(collection).map(col => (
              <div className="brochures">
                <Collection
                  key={col[0].pageID}
                  content={col}
                  header="workbooks"
                />
              </div>
          ))}
        {url.split('/').slice(-1).pop() === 'dealer-programs' &&
            Object.values(collection).map(col => (
              <div className="brochures">
                <Collection
                  key={col[0].pageID}
                  content={col}
                  header="dealer programs"
                />
              </div>
          ))}
        {url.split('/').slice(-1).pop() === 'malibu-competitive-comparisons' &&
            Object.values(collection).map(col => (
              <div className="videos">
                <Collection
                  key={col[0].pageID}
                  content={col}
                  header="malibu competitive comparisons"
                />
              </div>
          ))}
        {url.split('/').slice(-1).pop() === 'axis-competitive-comparison' &&
            Object.values(collection).map(col => (
              <div className="videos">
                <Collection
                  key={col[0].pageID}
                  content={col}
                  header="axis competitive comparison"
                />
              </div>
            ))}
        {url.split('/').slice(-1).pop() === 'malibu-competitive-analysis' &&
              Object.values(collection).map(col => (
                <div className="videos">
                  <Collection
                    key={col[0].pageID}
                    content={col}
                    header="malibu competitive analysis"
                  />
                </div>
            ))}
        {url.split('/').slice(-1).pop() === 'axis-competitive-analysis' &&
              Object.values(collection).map(col => (
                <div className="videos">
                  <Collection
                    key={col[0].pageID}
                    content={col}
                    header="axis competitive analysis"
                  />
                </div>
            ))}
        {url.split('/').slice(-1).pop() === 'sales-training-videos' &&
            Object.values(collection).map(col => (
              <div className="videos">
                <Collection
                  key={col[0].pageID}
                  content={col}
                  header="sales training videos"
                />
              </div>
          ))}
        {url.split('/').slice(-1).pop() === 'product-overview' &&
            Object.values(collection).map(col => (
              <div className="brochures">
                <Collection
                  key={col[0].pageID}
                  content={col}
                  header="product overview"
                />
              </div>
          ))}
        {escaped && <Redirect to={url.substring(0, redirPath)} />}
      </div>
    );
  }
}

CollectionView.propTypes = {
  match: PropTypes.shape().isRequired,
};
